import { SvgIcon, SvgIconProps } from '@mui/material'

const SrpTipProtectionIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 32 32">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6440_54324)">
                <path d="M16.6667 28H11.4321C10.4766 28 9.55271 27.6579 8.82757 27.0357C8.10244 26.4136 7.62396 25.5524 7.47873 24.608L5.8054 13.7387C5.74696 13.3586 5.77138 12.9705 5.87701 12.6008C5.98263 12.2311 6.16695 11.8886 6.41733 11.5968C6.66771 11.305 6.97822 11.0708 7.32759 10.9103C7.67696 10.7497 8.05691 10.6666 8.4414 10.6667H23.5601C23.9446 10.6666 24.3245 10.7497 24.6739 10.9103C25.0232 11.0708 25.3338 11.305 25.5841 11.5968C25.8345 11.8886 26.0188 12.2311 26.1245 12.6008C26.2301 12.9705 26.2545 13.3586 26.1961 13.7387L25.6414 17.3387" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 14.6667V8C12 6.93913 12.4214 5.92172 13.1716 5.17157C13.9217 4.42143 14.9391 4 16 4C17.0609 4 18.0783 4.42143 18.8284 5.17157C19.5786 5.92172 20 6.93913 20 8V14.6667" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21.3333 28L27.9999 21.3333" stroke="#FEC524" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M28 28V28.0133" stroke="#FEC524" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21.3333 21.3333V21.3467" stroke="#FEC524" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_6440_54324">
                    <rect width="32" height="32" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    </SvgIcon>
)

export default SrpTipProtectionIcon
